function upsertMeta(selector, attributes) {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([name, value]) => {
    if (value) {
      element.setAttribute(name, value);
    }
  });
}

function upsertLink(selector, attributes) {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("link");
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([name, value]) => {
    if (value) {
      element.setAttribute(name, value);
    }
  });
}

function clearGeneratedHeadNodes() {
  document.head
    .querySelectorAll(
      "[data-ferrysearch-seo='alternate'], [data-ferrysearch-seo='og-locale-alt'], link[rel='alternate'][hreflang], meta[property='og:locale:alternate']",
    )
    .forEach((node) => node.remove());
}

export function applySeoToDocument(seo) {
  if (typeof document === "undefined" || !seo) {
    return;
  }

  document.documentElement.lang = seo.htmlLang || "en-GB";
  document.title = seo.title || "FerrySearch";

  upsertMeta("meta[name='description']", {
    content: seo.description,
    name: "description",
  });
  upsertMeta("meta[name='robots']", {
    content: seo.robots,
    name: "robots",
  });
  upsertMeta("meta[property='og:title']", {
    content: seo.og?.title,
    property: "og:title",
  });
  upsertMeta("meta[property='og:description']", {
    content: seo.og?.description,
    property: "og:description",
  });
  upsertMeta("meta[property='og:url']", {
    content: seo.og?.url,
    property: "og:url",
  });
  upsertMeta("meta[property='og:site_name']", {
    content: seo.og?.siteName,
    property: "og:site_name",
  });
  upsertMeta("meta[property='og:locale']", {
    content: seo.og?.locale,
    property: "og:locale",
  });
  upsertMeta("meta[property='og:type']", {
    content: seo.og?.type,
    property: "og:type",
  });
  upsertMeta("meta[property='og:image']", {
    content: seo.og?.imageUrl,
    property: "og:image",
  });
  upsertMeta("meta[name='twitter:card']", {
    content: seo.twitter?.card,
    name: "twitter:card",
  });
  upsertMeta("meta[name='twitter:title']", {
    content: seo.twitter?.title,
    name: "twitter:title",
  });
  upsertMeta("meta[name='twitter:description']", {
    content: seo.twitter?.description,
    name: "twitter:description",
  });
  upsertMeta("meta[name='twitter:image']", {
    content: seo.twitter?.imageUrl,
    name: "twitter:image",
  });
  upsertLink("link[rel='canonical']", {
    href: seo.canonicalUrl,
    rel: "canonical",
  });

  clearGeneratedHeadNodes();

  Object.entries(seo.alternates || {}).forEach(([languageTag, href]) => {
    const alternate = document.createElement("link");
    alternate.setAttribute("data-ferrysearch-seo", "alternate");
    alternate.setAttribute("rel", "alternate");
    alternate.setAttribute("hreflang", languageTag);
    alternate.setAttribute("href", href);
    document.head.appendChild(alternate);
  });

  if (seo.xDefaultUrl) {
    const xDefault = document.createElement("link");
    xDefault.setAttribute("data-ferrysearch-seo", "alternate");
    xDefault.setAttribute("rel", "alternate");
    xDefault.setAttribute("hreflang", "x-default");
    xDefault.setAttribute("href", seo.xDefaultUrl);
    document.head.appendChild(xDefault);
  }

  Object.keys(seo.alternates || {}).forEach((languageTag) => {
    const ogLocale = String(languageTag).replace("-", "_");
    if (!ogLocale || ogLocale === seo.og?.locale) {
      return;
    }

    const element = document.createElement("meta");
    element.setAttribute("data-ferrysearch-seo", "og-locale-alt");
    element.setAttribute("property", "og:locale:alternate");
    element.setAttribute("content", ogLocale);
    document.head.appendChild(element);
  });
}
